import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import ShowroomSection from "../components/ShowroomSection";
import VideoCarousel from "../components/VideoCarousel";
import NewArrival from "../components/NewArrival";
import RMGservices from "../components/RMGservices";
import ServicesSection from "../components/ServicesSection";
import Banner from "../components/Banner";

const Home: React.FC = () => {
  const { t, i18n } = useTranslation();

  const videos = [
    {
      id: 1,
      src: "/videos/HomeCarrousel/Home07.webm",
      title: t("videoCarousel.videos.0.title"),
      subject: t("videoCarousel.videos.0.subject"),
      discoverText: t("videoCarousel.videos.0.discoverText"),
      link: `${window.location.origin}/${i18n.language}`,
    },
    {
      id: 2,
      src: "/videos/HomeCarrousel/Home02.webm",
      title: t("videoCarousel.videos.1.title"),
      subject: t("videoCarousel.videos.1.subject"),
      discoverText: t("videoCarousel.videos.1.discoverText"),
      link: `${window.location.origin}/${i18n.language}`,
    },
    {
      id: 3,
      src: "/videos/HomeCarrousel/Home03.webm",
      title: t("videoCarousel.videos.2.title"),
      subject: t("videoCarousel.videos.2.subject"),
      discoverText: t("videoCarousel.videos.2.discoverText"),
      link: `${window.location.origin}/${i18n.language}`,
    },
  ];

  return (
    <>
      <Helmet>
        <title>{t("helmet.home.title")}</title>
        <meta name="description" content={t("helmet.home.description")} />
        <meta charSet="UTF-8" />
        <meta httpEquiv="Content-Language" content={i18n.language} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>

      <section className="video-container-home">
        <VideoCarousel videos={videos} />
      </section>

      <NewArrival />

      <RMGservices />

      <ServicesSection />

      <ShowroomSection />

      <Banner />
    </>
  );
};

export default Home;
